import { Heading, Grid, Text } from '@simplywallst/ui-core';

import { formatterCurrency } from '@/utilities/format';

import { useFairValueContext } from '@/components/CompanyFairValue';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';

import type { WatchlistItem } from '@/hooks/useWatchlist';
import type { Holding } from '@/hooks/usePortfolio';

import { EditIcon } from './styled';

import type { LocationState } from 'redux-first-router';
import { ROUTE_WATCHLIST } from '@/constants/routes';
import { useSelector } from 'react-redux';

export const useShouldShowFairValueTile = () => {
  const isWatchlistRoute = useSelector<{ location: LocationState }>((state) => {
    return state.location.type === ROUTE_WATCHLIST;
  });

  if (!isWatchlistRoute) {
    return false;
  }

  if (TEST_RUNNER === 'cypress') {
    return true;
  }

  return SWS_ENV === 'local' || SWS_ENV === 'dev';
};

interface Props {
  company: WatchlistItem['company'] | Holding['company'];
  fairValue?: number | null;
}

export const FairValue = ({ company, fairValue }: Props) => {
  const { actions } = useFairValueContext();

  return (
    <Grid templateColumns="repeat(2, 1fr)" alignItems="start">
      <Grid>
        <Heading
          as="h3"
          typography="tinyStrong"
          color="whiteRGBA"
          opacity={0.5}
        >
          Fair Value
        </Heading>
        <Grid
          as="button"
          aria-label="Open fair value modal"
          onClick={actions.toggleFairValueModal}
          templateColumns="min-content min-content"
        >
          <Text as="span" typography="small" color="brand01">
            {formatterCurrency(
              fairValue ?? company.analysisValue.npvPerShare,
              company.data.currencyInfo.trading_item_currency_iso
            )}
          </Text>
          <EditIcon />
        </Grid>
      </Grid>
      <Grid>
        <Heading
          as="h3"
          typography="tinyStrong"
          color="whiteRGBA"
          opacity={0.5}
        >
          Current Price
        </Heading>
        <Text typography="small">
          {formatterCurrency(
            company.analysisValue.lastSharePrice,
            company.data.currencyInfo.trading_item_currency_iso
          )}
        </Text>
        <Text typography="tinyCondensed" color="whiteRGBA" opacity={0.5}>
          <CompanyIntrinsicDiscount company={company} fairValue={fairValue} />
        </Text>
      </Grid>
    </Grid>
  );
};
